import React from 'react'
import { Review } from '../models/shared/Review';
import { DateFormat, DisplaySettings } from '../models/shared/Settings';
import Rating from './Rating';
import Time from './Time';
import { formatName } from '../utils/shared/names';

interface Props {
    index: number;
    animation: string;
    review: Review;
    displaySettings?: DisplaySettings;

}

const MAX_CHARACTERS = 105;
const BASE_HEIGHT = 150;
const SMALL_HEIGHT = 120;
const BASE_TEXT_SIZE = 13;

function ReviewBox(props: Props) {
    const { index, review, displaySettings } = props

    const dateFormat: DateFormat = displaySettings?.dateFormat || 'DD/MM/YYYY';
    const size = displaySettings?.size || 1;
    const isOnPhone = window.innerWidth < 768 ? true : false;
    const baseHeight = isOnPhone ? SMALL_HEIGHT : BASE_HEIGHT;
    const height = Math.round(baseHeight * size);

    let shortenedText = review.text;
    const textLength = review.text?.length || 0;
    if (size === 1 && textLength > MAX_CHARACTERS) {
        shortenedText = review.text.slice(0, MAX_CHARACTERS) + ' ...';
    }

    const authorName = formatName(review.author_name, displaySettings?.nameFormat);

    let reviewLink = displaySettings?.placeUrl
    if (review.author_url && !displaySettings?.manual && !isOnPhone) {
        reviewLink = review.author_url.replace('/reviews', '/place/' + displaySettings?.placeId);
    }

    const renderContent = () => {
        // console.log('rendering', review.author_name)
        return <>
            <div className='author'>
                <img src={review.profile_photo_url} alt={authorName} />
                <div className='name' style={{
                    fontFamily: displaySettings?.nameFont || '',
                    fontSize: displaySettings?.nameSize || '',

                }}>{authorName}</div>
            </div>

            <Rating rating={review.rating} />
            <div className='text' style={{ fontFamily: displaySettings?.textFont || '' }}>{shortenedText}</div>
            <Time time={review.time} format={dateFormat} displaySettings={displaySettings} />
        </>
    }

    const textSize = displaySettings?.textSize || 1;
    const containerStyle: React.CSSProperties = {
        animation: props.animation,
        height: `${height}px`,
        fontSize: `${Math.round(BASE_TEXT_SIZE * textSize)}px`,
    }
    if (displaySettings?.backgroundColor) {
        containerStyle['backgroundColor'] = displaySettings.backgroundColor;
    }
    if (displaySettings?.textColor) {
        containerStyle['color'] = displaySettings.textColor;
    }

    return <div key={index} className={`review ${size === 1 && 'review-hover'}`}
        style={containerStyle}>
        {displaySettings?.noLinks
            ? renderContent()
            : <a key={index} href={reviewLink} className='plain h-100' target='_blank' rel='noreferrer'  >
                {renderContent()}
            </a>
        }
    </div>
}

export default ReviewBox
